<template>
  <div class="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl shadow-lg p-6 border border-blue-200">
    <h2 class="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
      <span>🔮</span>
      Proyecciones del Período
    </h2>

    <!-- Info del Período -->
    <div class="grid grid-cols-3 gap-4 mb-6">
      <div class="bg-white rounded-lg p-3">
        <p class="text-xs text-gray-600 mb-1">Días Transcurridos</p>
        <p class="text-2xl font-bold text-blue-600">{{ proyecciones.dias_transcurridos }}</p>
      </div>
      <div class="bg-white rounded-lg p-3">
        <p class="text-xs text-gray-600 mb-1">Días Restantes</p>
        <p class="text-2xl font-bold text-purple-600">{{ proyecciones.dias_restantes }}</p>
      </div>
      <div class="bg-white rounded-lg p-3">
        <p class="text-xs text-gray-600 mb-1">Confianza</p>
        <span :class="getConfianzaBadgeClass(proyecciones.confianza)" class="inline-block px-3 py-1 rounded-full text-sm font-semibold mt-1">
          {{ proyecciones.confianza }}
        </span>
      </div>
    </div>

    <!-- Promedios Diarios -->
    <div class="bg-white rounded-lg p-4 mb-6">
      <h3 class="font-semibold text-gray-900 mb-3">Promedios Diarios</h3>
      <div class="grid grid-cols-2 gap-4">
        <div>
          <p class="text-sm text-gray-600 mb-1">Ventas por Día</p>
          <p class="text-3xl font-bold text-gray-900">{{ proyecciones.promedios_diarios.ventas.toFixed(1) }}</p>
        </div>
        <div>
          <p class="text-sm text-gray-600 mb-1">Valor por Día</p>
          <p class="text-2xl font-bold text-green-600">{{ formatearMoneda(proyecciones.promedios_diarios.valor) }}</p>
        </div>
      </div>
    </div>

    <!-- Proyección Fin de Período -->
    <div class="bg-gradient-to-r from-purple-100 to-pink-100 rounded-lg p-4 border-2 border-purple-300">
      <h3 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
        <span>📈</span>
        Proyección al Final del Período
      </h3>
      <div class="grid grid-cols-2 gap-4">
        <div class="bg-white rounded-lg p-3">
          <p class="text-sm text-gray-600 mb-1">Ventas Estimadas</p>
          <p class="text-4xl font-bold text-purple-600">{{ proyecciones.proyeccion_fin_periodo.ventas_estimadas }}</p>
        </div>
        <div class="bg-white rounded-lg p-3">
          <p class="text-sm text-gray-600 mb-1">Valor Estimado</p>
          <p class="text-2xl font-bold text-green-600">{{ formatearMoneda(proyecciones.proyeccion_fin_periodo.valor_estimado) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Proyecciones',
  props: {
    proyecciones: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatearMoneda(valor) {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(valor);
    },
    getConfianzaBadgeClass(confianza) {
      switch (confianza) {
        case 'ALTA':
          return 'bg-green-100 text-green-800';
        case 'MEDIA':
          return 'bg-yellow-100 text-yellow-800';
        case 'BAJA':
          return 'bg-red-100 text-red-800';
        default:
          return 'bg-gray-100 text-gray-800';
      }
    }
  }
};
</script>
